import apiRequest from "@app/utils/apiRequest";

// Run job APIs
export const requestCheckFollowUpDVTJCUV = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/check-follow-up`, data)
export const requestAddCddToFollowUpTabDVTJCUV = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/add-cdd-follow-up-tab`, data)
export const requestGroupPipelineByStragyCompaignNextDVTJCUV = (data) => apiRequest.post(`/dvtjcuv/run-dvtjcuv/group-pipeline-by-stragy-compagin-next`, data)
